import $ from 'jquery'
$(document).ready(function() {
	/*
	 * Customise select
	 */

	//customised check box
	const checkboxs = $('.gform_wrapper input[type=checkbox]')

	checkboxs.each(function() {
		$(this).wrap('<div class="customCheckbox"></div>')
		$(this).before('<span><i class="fa fa-check" aria-hidden="true"></i></span>')
		$(this)
			.parent()
			.toggleClass('customCheckboxChecked', $(this).is(':checked'))
	})

	checkboxs.change(function() {
		$(this)
			.parent()
			.toggleClass('customCheckboxChecked', $(this).is(':checked'))
	})

	//customised radio
	const radio = $('.gform_wrapper input[type=radio]')

	radio.each(function() {
		$(this).wrap('<div class="customCheckbox radio"></div>')
		$(this).before('<span><i class="fa fa-check" aria-hidden="true"></i></span>')
		if ($(this).is(':checked')) {
			$(this)
				.parent()
				.addClass('customCheckboxChecked')
			$(this)
				.parent()
				.parent()
				.siblings()
				.find('.customCheckbox')
				.removeClass('customCheckboxChecked')
		}
	})

	radio.change(function() {
		if ($(this).is(':checked')) {
			$(this)
				.parent()
				.addClass('customCheckboxChecked')
			$(this)
				.parent()
				.parent()
				.siblings()
				.find('.customCheckbox')
				.removeClass('customCheckboxChecked')
		}
	})

	//Scroll to the Gravity form once the form was submitted.
	if ($('.gform_confirmation_message').length) {
		$('html, body').scrollTop($('.gform_confirmation_message').offset().top)
	} else if ($('.validation_error').length && $('.gform_wrapper').length) {
		$('html, body').scrollTop($('.gform_wrapper').offset().top)
	}

	//Feedback form customisation;
	$('#feedback-complaints li').on('click', function() {
		if ($(this).hasClass('is-active')) {
			return
		}

		$(this)
			.addClass('is-active')
			.siblings()
			.removeClass('is-active')
		$('.gfield.feedback-complaints input').val($(this).text())
	})

	//Based on gravity form
	$('.gfield input[type="file"]:not([multiple])').each(function() {
		//Clear stored file
		$(this).val('')
		const inputID = $(this).attr('id')
		const targetGfield = $(this).closest('.gfield')
		targetGfield.addClass('has-single-file-input')
		$(
			'<label class="fw-file-upload-label btn btn-default" for="' +
				inputID +
				'"><i class="fa fa-upload"></i><span class="file-input-text">Select a file</span></label>'
		).insertBefore($(this))
		$(this).on('change', function() {
			if (
				$(this)
					.siblings('.validation_message')
					.text() ||
				!$(this).val()
			) {
				$(this)
					.siblings('.fw-file-upload-label')
					.find('.file-input-text')
					.text('Select a file')
			} else {
				$(this)
					.siblings('.fw-file-upload-label')
					.find('.file-input-text')
					.text(
						$(this)
							.val()
							.split('\\')
							.slice(-1)[0]
					)
			}
		})
	})
})
